/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Partner } from './partner';


export interface PoliceRole { 
    role: PoliceRole.RoleEnum;
    policennummer: string;
    partner: Partner;
}
export namespace PoliceRole {
    export type RoleEnum = 'praemienzahler' | 'versicherungsnehmer' | 'versicherter' | 'sammelzahler' | 'listenzahler' | 'hypothekarschuldner' | 'zeichnungsberechtigter' | 'zeichnungsberechtigter2' | 'stellvertreterinland' | 'beistand' | 'vormund' | 'gesetzlichervertreter' | 'korrespondanzadresse' | 'vnwohnsitz' | 'wirtschaftlichberechtigter' | 'korrespondanzadresse1x' | 'kontrollinhaberVn' | 'kontrollinhaberPz' | 'unwidderBeguenErl' | 'unwidderBeguenTod' | 'pfandglaubiger' | 'auszahlungsempfaenger' | 'obsoletebeziehungsart50' | 'auskunftsvollmacht' | 'maklermandat' | 'aenderungsvollmacht' | 'anspruchsberechtigter' | 'drittbank';
    export const RoleEnum = {
        PRAEMIENZAHLER: 'praemienzahler' as RoleEnum,
        VERSICHERUNGSNEHMER: 'versicherungsnehmer' as RoleEnum,
        VERSICHERTER: 'versicherter' as RoleEnum,
        SAMMELZAHLER: 'sammelzahler' as RoleEnum,
        LISTENZAHLER: 'listenzahler' as RoleEnum,
        HYPOTHEKARSCHULDNER: 'hypothekarschuldner' as RoleEnum,
        ZEICHNUNGSBERECHTIGTER: 'zeichnungsberechtigter' as RoleEnum,
        ZEICHNUNGSBERECHTIGTER2: 'zeichnungsberechtigter2' as RoleEnum,
        STELLVERTRETERINLAND: 'stellvertreterinland' as RoleEnum,
        BEISTAND: 'beistand' as RoleEnum,
        VORMUND: 'vormund' as RoleEnum,
        GESETZLICHERVERTRETER: 'gesetzlichervertreter' as RoleEnum,
        KORRESPONDANZADRESSE: 'korrespondanzadresse' as RoleEnum,
        VNWOHNSITZ: 'vnwohnsitz' as RoleEnum,
        WIRTSCHAFTLICHBERECHTIGTER: 'wirtschaftlichberechtigter' as RoleEnum,
        KORRESPONDANZADRESSE1X: 'korrespondanzadresse1x' as RoleEnum,
        KONTROLLINHABER_VN: 'kontrollinhaberVn' as RoleEnum,
        KONTROLLINHABER_PZ: 'kontrollinhaberPz' as RoleEnum,
        UNWIDDER_BEGUEN_ERL: 'unwidderBeguenErl' as RoleEnum,
        UNWIDDER_BEGUEN_TOD: 'unwidderBeguenTod' as RoleEnum,
        PFANDGLAUBIGER: 'pfandglaubiger' as RoleEnum,
        AUSZAHLUNGSEMPFAENGER: 'auszahlungsempfaenger' as RoleEnum,
        OBSOLETEBEZIEHUNGSART50: 'obsoletebeziehungsart50' as RoleEnum,
        AUSKUNFTSVOLLMACHT: 'auskunftsvollmacht' as RoleEnum,
        MAKLERMANDAT: 'maklermandat' as RoleEnum,
        AENDERUNGSVOLLMACHT: 'aenderungsvollmacht' as RoleEnum,
        ANSPRUCHSBERECHTIGTER: 'anspruchsberechtigter' as RoleEnum,
        DRITTBANK: 'drittbank' as RoleEnum
    };
}


